import { action, observable, makeObservable } from 'mobx';

export class LiveTrackerIframeState {
    @observable public isOpen: boolean;
    @observable public mountKey: number = 0;

    public constructor(isOpen: boolean) {
        makeObservable(this);

        this.isOpen = isOpen;
    }

    @action public toggle = (): void => {
        this.isOpen = !this.isOpen;

        if (this.isOpen) {
            this.mountKey += 1;
        }
    };
}
